module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"sl":{"installApp":"Namestim Dialog Web App na domač zaslon?","install":"Namesti!","noInstall":"Ne, hvala"},"en":{"installApp":"Add app to home screen?","install":"Install!","noInstall":"No, thanks"},"de":{"installApp":"App zum Startbildschirm hinzufügen?","install":"Installieren!","noInstall":"Nein, Danke"}}')
  delete Component.options._Ctor
}
